import React, { PureComponent } from 'react';
import MapInterface from './MapTableInterface.js';
// I need to have the parent data in the state
// and update it with select interfaces
// But i need to loop through the parent data to have the select interfaces

class MapTableEditForm extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			name: this.props.data.label
		};
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onChangeParent = this.onChangeParent.bind(this);
	}
	
	onChange(e) {
		this.setState({[e.target.name]: e.target.value}, ()=>{console.log(this.state)});
	}
	
	onChangeParent(e) {
		this.setState({[e.target.name]: e.target.value.value}, ()=>{console.log(this.state)});
	}
	
	onSubmit(e) {
		e.stopPropagation();
		e.preventDefault();
		if (this.props.onSubmit)
			this.props.onSubmit(this.state);
	}
	
	/*
	componentDidUpdate(prevProps) {
		if (!this.props.data)
			return;
		
		if (this.props.data.label !== prevProps.data.label) {
			this.setState({name: this.props.data.label});
		}
	}*/
	
	render() {
		let parents = [];
		if (this.props.parents) {
			for(let i=0; i < this.props.parents.length; i++) {
				parents.push(<MapInterface 
					maptable={this.props.parents[i]}
					name={this.props.parents[i] + "ID"}
					onChange={this.onChangeParent}
					key={i}
				/>);
			}
		}
		return (
			<form onSubmit={this.onSubmit}>
				<div className="parent">{parents}</div>
				<label>New name</label>
				<input type="text" name="name" value={this.state.name} onChange={this.onChange} placeholder={this.props.placeholder || 'Name'} />
				<input type="submit" value="Save" />
			</form>);
	}
}

export default MapTableEditForm;
